import { render, staticRenderFns } from "./PointWriteDefaultLayout.vue?vue&type=template&id=ceddea98&scoped=true"
import script from "./PointWriteDefaultLayout.vue?vue&type=script&lang=js"
export * from "./PointWriteDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceddea98",
  null
  
)

export default component.exports